import { MediaQuery } from 'utils/media_query';
import 'utils/serialize_object';
import 'components/empty_list_message';
import './index.scss';

export default function ($) {
  'use strict';

  const $component = $('.q-subject-group-item');
  $('.panel-heading .q-open', $component).addClass('hidden');
  $('.panel-heading .q-close', $component).removeClass('hidden');

  $('.collapse', $component)
    .on('show.bs.collapse', e => {
      const $heading = $(e.currentTarget).prev('.panel-heading');

      $heading.find('.q-open').addClass('hidden');
      $heading.find('.q-close').removeClass('hidden');
    })
    .on('hide.bs.collapse', e => {
      const $heading = $(e.currentTarget).prev('.panel-heading');

      $heading.find('.q-open').removeClass('hidden');
      $heading.find('.q-close').addClass('hidden');
    });

  $('.js-check-all', $component).on('change', e => {
    const $checkbox = $(e.currentTarget);
    const $parent = $checkbox.parents('.q-subject-group-item');
    const $nestedSubjects = $('.q-nested-subjects', $parent);

    $('input[type="checkbox"]', $nestedSubjects).prop('checked', $checkbox.is(':checked')).trigger('change');
  });

  if (MediaQuery.is('lt_lg')) {
    $('.js-nested-subjects', $component).first().collapse('show');
  }

  if (MediaQuery.is('lg')) {
    $('.js-nested-subjects', $component).collapse('show');
  }
}
